import { useTheme } from '@emotion/react'
import type { FC } from 'react'

import Image from '@segment/matcha/components/Image'

interface FaqImageProps {
  alt: string
  mobile: string
  desktop: string
  mobileWebp: string
  desktopWebp: string
  height: number
}

const FaqImage: FC<FaqImageProps> = ({ alt, mobile, desktop, mobileWebp, desktopWebp, height }) => {
  const theme = useTheme()
  return (
    <picture>
      <source
        type="image/webp"
        media={theme.breakpoints.up(`lg`, false)}
        srcSet={`${desktopWebp}`}
        width="844"
        height={height}
      />
      <source media={theme.breakpoints.up(`lg`, false)} srcSet={`${desktop}`} width="844" height={height} />
      <source type="image/webp" srcSet={`${mobileWebp}`} width="576" height={height} />
      <Image src={mobile} alt={`Illustration: ${alt}`} width="844" height={height} loading="lazy" />
    </picture>
  )
}

export default FaqImage
